;(function ($) {
    /**
     * gio 埋点
     * */
    window.gioTrackAction = {

        gio_base: function(tag, params){
            // console.log(tag, params);
            if (params){
                // 循环params对象，将key为phoneNumber的值脱敏，将key为email删除,将key为userName删除，将key为company删除
                for (var key in params) {
                    if (key === 'phoneNumber') {
                        params[key] = common.mobileEncryption(params[key]);
                    }
                    if (key === 'email' || key === 'userName' || key === 'company') {
                        delete params[key];
                    }
                }
                gio('track', tag, params);
            }else {
                gio('track', tag);
            }
        },

        //点击收藏时触发
        collect : function () {
            this.gio_base('favoriteClick');
        },

        // 收藏成功
        collectSuccess: function(){
            this.gio_base('favoriteSuccess');
        },

        // 发布评论成功
        commentSend : function () {
            this.gio_base('commentSuccess');
        },

        // 确认下载
        downloadConfirm: function(){
            this.gio_base('downloadConfirm');
        },

        // 售前咨询
        // 内容详情页中（解决方案、案例智库、资料中心、轻阅读、产品评测）
        // 1.点击页尾“在线咨询”时触发
        // 2.点击侧边栏“在线咨询”时触发
        presalesConsult: function () {
            this.gio_base('click_presalesConsult');
        },

        // 项目咨询
        // 点击内容页尾“项目咨询”时触发（解决方案、案例智库、资料中心、轻阅读、产品评测）
        projectConsult: function () {
            this.gio_base('buysubmitclick_content');
        },

        // 项目咨询-点击-新站右侧浮窗
        projectConsult_floatWindow: function () {
            this.gio_base('buysubmit_floatFormclick');
        },

        // 点击右下角“项目咨询”弹窗时触发
        projectConsult_timingWindow : function () {
            this.gio_base('buysubmitclick_message');
        },

        // 点击推荐内容
        // position 点击推荐内容位置
        recommendContentClick: function (position, id, title, contentID) {
            var id = id||'';
            var title = title||'';
            var recommendContentID = '';
            if(document.querySelector('#contentID')){
                recommendContentID = document.querySelector('#contentID').value
            }
            if(contentID){
                recommendContentID = contentID;
            }
            this.gio_base('recommendClick', {'recommendPosition_var': position, 'recommendContent_var':id, 'recommendTitle_var':title, 'recommendContentID_var':recommendContentID })
        },

        // 推荐位曝光
        recommendImp: function (position, id ,title, contentID) {
            this.gio_base('recommendImp', {'recommendPosition_var': position, 'recommendContent_var':id, 'recommendTitle_var':title, 'recommendContentID_var':contentID  })
        },

        //多云课堂结束观看视频
        cloudEndPlayVideo: function(watchTime, videoId, videoName) {
            this.gio_base('webinarcloud_videoWatchend', {'webinarcloud_watchTime': watchTime, 'webinarcloud_video_id': videoId, 'webinarcloud_video_name': videoName});
        },

        // 浏览产品详情页
        viewProductDetail: function(){
            this.gio_base('eshop_productDetailsPV');
        },

        /**
         * 搜索
         * @param keyword 搜索关键字
         * @param success 是否搜索成功 是/否
         * @param source 搜索来源  手动搜索/热门搜索/热搜推荐
         * */
        search: function (keyword, success, source) {
            // 搜索成功次数
            this.gio_base('searchSuccess',{
                'searchWord_var': keyword,
                'searchSuccess_var': success,
                'searchSource_var': source
            });
            // eshop商品搜索
            this.gio_base('eshop_searchSuccess', {
                'eshop_searchwords': keyword,
                'eshop_searchresults': success,
                'eshop_searchType_var': source
            });
        },

        /**
         * 点击搜索结果
         * @param keyword 搜索关键字
         * @param source 搜索来源  手动搜索/热门搜索
         * @param resultType_var  搜索类型  搜索结果、最新商品
         * */
        searchResultClick: function (keyword, source, type) {
            this.gio_base('searchResultClick',{
                'searchWord_var': keyword,
                'searchSource_var': source,
                'resultType_var': type || '搜索结果'
            })
        },


        // 爆款弹窗
        popupDialog: function (type, prodId){
            var _this = this;

            var pageConfigId = null; //如果没有传来的产品id尝试获取页面设置的产品id
            try {
                pageConfigId = pageConfig.productId;
            }catch (e) {

            }
            var prodId = prodId || pageConfigId ||'';
            var triggerReason_var = window.userRecordOption ? (window.userRecordOption.triggerReason_var || '') : '';
            var gioParams = {'popupType_var':type, 'recommendContent_var':prodId, 'triggerReason_var': triggerReason_var};
            return {
                open:function () {
                    if (type == '爆款') {
                        gioParams.closeType_var = window.userRecordOption.closeType_var;
                    }
                    _this.gio_base('popupImp', gioParams);
                },

                click:function () {
                    _this.gio_base('popupClick', gioParams);
                },

                close:function () {
                    if (type == '爆款') {
                        gioParams.closeType_var = window.userRecordOption.closeType_var;
                    }
                    _this.gio_base('popupClose', gioParams);
                }
            }
        },

        // 调查问卷提交
        surveySubmit: function (params) {
            this.gio_base('verticalsurvey_submit',params)
        },

        //成长型企业活动页问卷提交
        permiumSubmit: function (params) {
            this.gio_base('premium_survey_submit',params);
        },

        shortVideoProductServer: function (title) {
            this.gio_base('Fromvideo_salechatClick',{
                title_pvar: title
            });
        },

        //首页顶部banner点击
        bannerClick: function (title, link) {
            this.gio_base('eshophomepage_topkv', {
                'eshophomepage_topkvtitle': title,
                'eshophomepage_topkvurl': link
            })
        },

        //首页定位模块点击
        fixBarClick: function (tabName) {
            this.gio_base('eshophomepage_tab', {
                'eshophomepage_tabname': tabName
            })
        },

        //首页栏目推荐模块产品点击
        indexRecommendClick: function (moduleName, productName, productModule) {
            this.gio_base('eshophomepage_product', {
                'eshophomepage_productSection': moduleName,
                'eshop_Productnumber_cms': productModule,
                'eshop_productname_cms': productName
            })
            gio('evar.set', {'eshophomepageSection_last_evar': moduleName, 'eshophomepageSection_linear_evar': moduleName});
            gio('evar.set', {'eshopProductnumber_last_evar': productModule, 'eshopProductnumber_linear_evar': productModule});
        },

        //首页栏目推荐模块banner点击
        indexRecommendBannerClick: function (moduleName, title, url) {
            this.gio_base('eshophomepage_productkv', {
                'eshophomepage_productSection': moduleName,
                'eshophomepage_productkvtitle': title || '',
                'eshophomepage_productkvurl': url
            })
        },

        //红包雨_立抢
        redPacketRainJoinclick:function () {
            this.gio_base('promotionhongbaoyu_joinclick')
        },
        //商城右侧浮标_topkv
        redPacketRainTopkv:function () {
            this.gio_base('eshophomepagefloaticonclick_topkv')
        },
        //商城右侧浮标_更多惊喜
        redPacketRainMore:function () {
            this.gio_base('eshophomepagefloaticonclick_more')
        },
        // 商城右侧浮标_免费抽奖
        redPacketRainChoujiang:function () {
            this.gio_base('eshophomepagefloaticonclick_choujiang')
        },
        // 商城右侧浮标_免费抽奖_更多
        redPacketRainChoujiangMore:function () {
            this.gio_base('eshophomepagefloaticonclick_choujiangmore')
        },
        // 商城右侧浮标_免费抽奖_关闭
        redPacketRainChoujiangClose:function () {
            this.gio_base('eshophomepagefloaticonclick_choujiangclose')
        },
        // 商城右侧浮标_0元试用
        redPacketRainTry:function () {
            this.gio_base('eshophomepagefloaticonclick_0try')
        },
        // 商城右侧浮标_小程序商城
        redPacketRainXiaochengxu:function () {
            this.gio_base('eshophomepagefloaticonclick_xiaochengxu')
        },

        // 商城侧边栏 资产回收
        siderBartradeIn:function () {
            this.gio_base('eshophomepagefloaticonclick_huanxin')
        },
        // 商城侧边栏 299意外险
        siderCoupon:function () {
            this.gio_base('eshophomepagefloaticonclick_yiwaixian')
        },

        // 商城红包雨_右侧浮标
        redPacketRainFloatIconclick:function () {
            this.gio_base('promotionhongbaoyu_floatIconclick')
        },
        // 商城红包雨_再逛逛
        redPacketRainStroll:function () {
            this.gio_base('promotionhongbaoyu_guangguang')
        },
        // 商城红包雨_领取
        redPacketRainReceive:function (userName, phoneNumber, email, company) {
            this.gio_base('promotionhongbaoyu_receive',{
                'company':company,
                'phoneNumber':phoneNumber,
                'email':email,
                'userName':userName
            })
        },

        // 首页活动弹窗曝光
        redPacketShow:function () {
            this.gio_base('eshophomepagepromotion_imp')
        },

        //商城详情页vip企采专享点击
        vipClick: function () {
            this.gio_base('click_VIPpricecontactus');
            common.setCookie('form_position', 'VIP企采专享价');
        },

        //商品详情页主推活动链接
        mainSaleLinkClick: function () {
            this.gio_base('eshopdetailOfferlink_click');
        },

        //: 导航mb链接
        navToMb: function () {
            this.gio_base('menu_event_mb');
        },

        // 点击导航自定义事件埋点
        navGioEvent: function (name, name1, name2, name3, isMore) {
            this.gio_base('solutioncom_publicmenuClick', {'publicmenuName': name, 'publicmenuName_category01': name1, 'publicmenuName_category02': name2, 'publicmenuName_category03': name3, 'publicmenuName_ifmore': isMore})
        },

        // 点击会员中心优惠券的立即使用按钮
        accountCouponClick: function (title, remark, scope) {
            this.gio_base('eshopmyaccount_couponclick', {
                'eshopcoupon_title': title,
                'eshopcoupon_Remark': remark,
                'eshopcoupon_scope': scope,
            })
        }
    };


    /*
    * gio 转换变量埋码
    * */
    window.gioEvarAction = {

        gio_base: function(key,value){
            gio('evar.set', key, value);
        },

        searchEvar : function (keyword) {
            this.gio_base('searchwords_last_evar',keyword);
            this.gio_base('searchwords_linear_evar',keyword);
        }
    }

})(jQuery)
